// oxlint-disable-next-line no-restricted-imports -- Legacy table migration/demo — do not copy into new code.
import { GridTableRow } from "@design-system/Tables/GridTable/GridTable";
import styles from "./ImporterPage.module.scss";

interface Props {
    rowNumber: number;
}

export const ImporterEmptyRow: React.FC<Props> = ({ rowNumber }) => {
    const stickyLeftNumber = 2;
    const otherNumber = 7;
    const stickyRightNumber = 1;
    return (
        <GridTableRow columnBorders className={styles.row}>
            <GridTableRow columnBorders className={styles.stickyLeft}>
                <div className={styles.rowNumber}>{rowNumber}</div>
                {Array.from({ length: stickyLeftNumber - 1 }).map(
                    (_, index) => (
                        <div key={`left-sticky-${index}`} />
                    ),
                )}
            </GridTableRow>
            {Array.from({ length: otherNumber }).map((_, index) => (
                <div key={`other-${index}`} />
            ))}
            <GridTableRow columnBorders className={styles.stickyRight}>
                {Array.from({ length: stickyRightNumber }).map((_, index) => (
                    <div key={`right-sticky-${index}`} />
                ))}
            </GridTableRow>
        </GridTableRow>
    );
};
